<template>
  <div class="member-item-new hover-trigger" tabindex="1">
    <div class="name">
      <Avatar :name="member.name" :url="previewFile(member.avatar)"></Avatar>
      <div class="flex-1">
        <div class="flex items-center">
          <div>{{ member.employeeName }}</div>
          <div class="account hover-item">(ID: {{ member.loginName }})</div>
          <EditOutlined class="edit-icon hover-item" @click="editName"></EditOutlined>
        </div>
        <div class="email">{{ member.email }}</div>
      </div>
    </div>
    <!-- <div class="department">{{ member.departments }}</div> -->
    <Menu v-if="editable && member.roles !== '拥有者'" :menus="menus" @click="handleMenuClick" meta="">
      <div class="role">
        {{ member.roles }}
        <CaretDownOutlined></CaretDownOutlined>
      </div>
    </Menu>
    <div v-else class="role">
      {{ member.roles }}
    </div>
    <!-- <div class="status">{{ member.stateName }}</div> -->
    <!-- <div class="date">{{ member.createdTime?.split(' ')[0] }}</div> -->
    <!-- <div class="operator">
      <Menu :menus="operators" @click="e => emit(e)">
        <EllipsisOutlined
          class="hover-item cursor-pointer"
          style="font-size: 16px"
          tabindex="-1"
        ></EllipsisOutlined>
      </Menu>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { Avatar, Modal, Menu } from '@elecmap/elecmap-ui'
import { computed, inject, reactive, type Ref } from 'vue'
import type { EmployeePageQuery } from '@elecmap/api/src/ram.d'
import { CaretDownOutlined, EditOutlined, EllipsisOutlined } from '@ant-design/icons-vue'
import { updateEmployee } from '@elecmap/api/src/ram'
import { pick } from 'lodash-es'
import type { EmMenuItem } from '@elecmap/elecmap-ui/lib/menu/types'
import { previewFile } from '@elecmap/api/src/cad/file'
import userStore from '@/store/user'
import { storeToRefs } from 'pinia'
import { renderIcon } from '@elecmap/icon'

const props = defineProps<{
  member: EmployeePageQuery
}>()

const emit = defineEmits(['memberChange', 'setRole', 'removeUser', 'exitOrg'])

const { canManage, userInfo } = storeToRefs(userStore())
const editable = computed(() => canManage.value && userInfo.value?.userId !== props.member.userId)
const operators = computed<EmMenuItem[][]>(() => {
  return [
    [
      {
        key: 'setRole',
        name: '设置角色',
        visible: canManage.value && userInfo.value?.userId !== props.member.userId,
      },
      {
        key: 'removeUser',
        name: '移除成员',
        visible: canManage.value && userInfo.value?.userId !== props.member.userId,
      },
      { key: 'exitOrg', name: '退出团队', visible: userInfo.value?.userId === props.member.userId },
    ],
  ] as EmMenuItem[][]
})

const menus: EmMenuItem[][] = [
  [
    {
      key: '251',
      name: '管理员',
      icon: renderIcon(),
    },
    { key: '253', name: '普通成员', icon: renderIcon() },
    // { key: '252', name: '组件库管理员', icon: renderIcon() },
  ],
  [
    {
      key: 'removeUser',
      name: '移除成员',
      visible: canManage.value && userInfo.value?.userId !== props.member.userId,
      icon: renderIcon()
    },
  ],
]

function handleMenuClick(key: string) {
  if (key === 'removeUser') {
    emit('removeUser')
    return
  }
  emit('setRole', key)
}

function editName() {
  Modal.form({
    width: '400px',
    title: `修改成员名称`,
    formItems: [
      {
        label: '名称',
        placeholder: '请输入名称',
        type: 'Input',
        key: 'employeeName',
      },
    ],
    formState: reactive({ keywords: { ...props.member }, tags: {} }),
    okText: '确认',
    onSubmit: ({ keywords }: any) => {
      updateEmployee({
        ...(pick(props.member, [
          'card',
          'email',
          'employeeId',
          'employeeName',
          'identification',
          'kingdeeCode',
          'userId',
          'organizationId',
        ]) as any),
        employeeId: props.member.id,
        employeeName: keywords.employeeName,
      }).then((data: EmployeePageQuery) => {
        data.roles = props.member.roles
        emit('memberChange', { ...data })
      })
    },
  })
}
</script>

<style lang="less" scoped>
.member-item-new {
  display: flex;
  width: calc(100% + 16px);
  transform: translateX(-8px);
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  transition: all 0.28s;
  border-radius: 5px;

  .name {
    display: flex;
    align-items: center;
    > div {
      margin-right: 8px;
    }
    :deep(.ant-avatar) {
      border-radius: 50%;
    }
    .account {
      transition: all 0.28s;
      margin: 0 4px;
      color: #bbb;
    }
    .edit-icon {
      transition: all 0.28s;
      cursor: pointer;
    }
  }

  .role {
    cursor: pointer;
  }

  &:hover,
  &:focus {
    background-color: #f5f5f5;
  }

  &:focus {
    .hover-item {
      opacity: 1;
    }
  }
}
</style>
